module.exports = __webpack_public_path__ + "static/media/act5.a9962caf.jpg";